export const cartMessages = {
  'cart.checkout': 'Checkout →',
  'cart.continue': 'Continue shopping →',
  'cart.empty': 'Your cart is empty',
  'cart.goShop': 'Browse products →',
  'cart.items': 'items',
  'cart.qty': 'Qty',
  'cart.sub': '',
  'cart.subtotal': 'Subtotal',
  'cart.title': 'My cart',
  'cart.total': 'Total',
  'cart.totalItems': 'items',
  'cart.unitPrice': 'Price',
  'checkout.addressTitle': 'Shipping address',
  'checkout.backCart': 'Back to cart',
  'checkout.emptyCart': 'Your cart is empty',
  'checkout.freeShipping': 'Free',
  'checkout.goAddAddress': 'Add address',
  'checkout.goodsTitle': 'Order items',
  'checkout.goodsTotal': 'Subtotal',
  'checkout.manageAddress': 'Manage addresses',
  'checkout.noAddress': 'Please select a shipping address',
  'checkout.noAddressHint': 'No addresses yet. Please add one.',
  'checkout.payable': 'Total',
  'checkout.shippingFee': 'Shipping',
  'checkout.submit': 'Place order',
  'checkout.submitFail': 'Failed to place order',
  'checkout.submitting': 'Placing order',
  'checkout.title': 'Checkout',
  'orderSuccess.amount': 'Amount',
  'orderSuccess.continue': 'Continue shopping',
  'orderSuccess.desc': 'Thank you for your purchase. We will ship soon.',
  'orderSuccess.orderNo': 'Order no.',
  'orderSuccess.title': 'Order placed',
  'orderSuccess.viewOrder': 'View order',
};
